

















import _ from 'lodash';
import { Component, Vue, Prop } from 'vue-property-decorator';
import InNameToolBox from '@/components/ColumnToolBox/InNameToolBox/index.vue';
import { RawLocation, Location } from 'vue-router';

@Component<LinkColumn>({
    name: 'LinkColumn',
    components: {
        InNameToolBox,
    },
})
export default class LinkColumn extends Vue {
    @Prop({ required: true, type: String }) private prop!: string;
    @Prop({ required: true, type: String }) private label!: string;
    @Prop({ type: String, default: 'left' }) private align!: string;
    @Prop({ type: [String, Number], default: '' }) private width!: number | string;
    @Prop({ type: [String, Number], default: 200 }) private minWidth!: number | string;
    @Prop({ type: [Boolean, String], default: false }) private sortable!: boolean | string;
    
    @Prop({ type: Object, default: () => {}}) private paramToAdd!: {
        campaignID?: boolean | string;
        adsetID?: boolean | string;
        adID?: boolean | string;
    };
    @Prop({ type: Object, required: true}) private to!: RawLocation;

    private makeTo (scope: any) {
        if (typeof(this.to) === 'string') {
            return this.to;
        }
        const par = this.paramToAdd as {
            campaignID?: string;
            adsetID?: string;
            adID?: string;
            adFolderID?: string;
            advertiserID?: string;
        }
        const res = _.cloneDeep(this.to) as Location;
        if (Object.keys(par).length) {
            res.params = {} as {[key: string]: string};
            const params = res.params as {[key: string]: string};
            Object.entries(par).forEach( (value: [string, string | undefined]) => {
                const k = value[0];
                const v = value[1] as string;
                params[k] = scope.row[v];
            })
        }
        return res;
    }
}
